import Repository from "./Repository";

const PAYMENT_RESOURCE = "/refund-group-slot-payments";
export default {
  groupRefund(payload) {
    return Repository.post(`${PAYMENT_RESOURCE}`, payload);
  },
};
